const VALIDATOR_TYPE_REQUIRE = 'REQUIRE';
const VALIDATOR_TYPE_MINLENGTH = 'MINLENGTH';
const VALIDATOR_TYPE_MAXLENGTH = 'MAXLENGTH';
const VALIDATOR_TYPE_MIN = 'MIN';
const VALIDATOR_TYPE_MAX = 'MAX';
const VALIDATOR_TYPE_EMAIL = 'EMAIL';
const VALIDATOR_TYPE_FILE = 'FILE';
const VALIDATOR_TYPE_ONE_FILE = 'FILE_NONE';
const VALIDATOR_TYPE_CPF_CNPJ = 'CPF_CNPJ';
const VALIDATOR_TYPE_CNPJ = 'CNPJ';
const VALIDATOR_TYPE_CPF = 'CPF';
const VALIDATOR_TYPE_CEP = 'CEP';
const VALIDATOR_TYPE_ARRAY_REQUIRE = 'ARRAY';
const VALIDATOR_TYPE_ARRAY_REQUIRE_TWO = 'ARRAY_TWO';

export const VALIDATOR_ARRAY_REQUIRE = () => ({ type: VALIDATOR_TYPE_ARRAY_REQUIRE });
export const VALIDATOR_ARRAY_REQUIRE_TWO = () => ({ type: VALIDATOR_TYPE_ARRAY_REQUIRE_TWO });
export const VALIDATOR_REQUIRE = () => ({ type: VALIDATOR_TYPE_REQUIRE });
export const VALIDATOR_FILE = () => ({ type: VALIDATOR_TYPE_FILE });
export const VALIDATOR_FILE_ONE = () => ({ type: VALIDATOR_TYPE_ONE_FILE });
export const VALIDATOR_MINLENGTH = (val) => ({
  type: VALIDATOR_TYPE_MINLENGTH,
  val
});
export const VALIDATOR_MAXLENGTH = (val) => ({
  type: VALIDATOR_TYPE_MAXLENGTH,
  val
});
export const VALIDATOR_MIN = (val) => ({ type: VALIDATOR_TYPE_MIN, val });
export const VALIDATOR_MAX = (val) => ({ type: VALIDATOR_TYPE_MAX, val });
export const VALIDATOR_EMAIL = () => ({ type: VALIDATOR_TYPE_EMAIL });
export const VALIDATOR_CPF_CNPJ = () => ({ type: VALIDATOR_TYPE_CPF_CNPJ });
export const VALIDATOR_CNPJ = () => ({ type: VALIDATOR_TYPE_CNPJ });
export const VALIDATOR_CPF = () => ({ type: VALIDATOR_TYPE_CPF });
export const VALIDATOR_CEP = () => ({ type: VALIDATOR_TYPE_CEP });

export const validate = (value, validators) => {
  let isValid = true;
  for (const validator of validators) {
    if (validator.type === VALIDATOR_TYPE_REQUIRE) {
      isValid = isValid && value.trim().length > 0;
    }
    if (validator.type === VALIDATOR_TYPE_FILE) {
      isValid = isValid && value.data.trim().length > 0;
    }
    if (validator.type === VALIDATOR_TYPE_ONE_FILE) {
      isValid = isValid && value.name.trim().length > 0;
    }
    if (validator.type === VALIDATOR_TYPE_MINLENGTH) {
      isValid = isValid && value.trim().length >= validator.val;
    }
    if (validator.type === VALIDATOR_TYPE_MAXLENGTH) {
      isValid = isValid && value.trim().length <= validator.val;
    }
    if (validator.type === VALIDATOR_TYPE_MIN) {
      isValid = isValid && +value >= validator.val;
    }
    if (validator.type === VALIDATOR_TYPE_MAX) {
      isValid = isValid && +value <= validator.val;
    }
    if (validator.type === VALIDATOR_TYPE_EMAIL) {
      isValid = isValid && /^\S+@\S+\.\S+$/.test(value);
    }
    if (validator.type === VALIDATOR_TYPE_CEP) {
      isValid = isValid && /^[0-9]{2}.[0-9]{3}-[0-9]{3}$/.test(value);
    }
    if (validator.type === VALIDATOR_TYPE_CNPJ) {
      // eslint-disable-next-line
      isValid = isValid && /^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/.test(value);
    }
    if (validator.type === VALIDATOR_TYPE_CPF) {
      // eslint-disable-next-line
      isValid = isValid && /^\d{3}\.\d{3}\.\d{3}\-\d{2}$/.test(value);
    }
    if (validator.type === VALIDATOR_TYPE_CPF_CNPJ) {
      // eslint-disable-next-line
      isValid = isValid && /^([0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}|[0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}\-?[0-9]{2})$/.test(value);
    }
    if (validator.type === VALIDATOR_TYPE_ARRAY_REQUIRE) {
      if (value === null || value === undefined) {
        isValid = false;
      } else {
        isValid = isValid && value.length > 0;
      }
    }
    if (validator.type === VALIDATOR_TYPE_ARRAY_REQUIRE_TWO) {
      if (value === null || value === undefined) {
        isValid = false;
      } else {
        isValid = isValid && value.length > 1;
      }
    }
  }
  return isValid;
};
